































































import { Component, Vue } from "vue-property-decorator";

@Component
export default class Promotions extends Vue {
  loading = false;

  menu = [
    {
      title: "Analisi",
      subtitle: "",
      children: [
        {
          title: "Brand Equity",
          to: "/promotion-brand-equity",
        },
        /* {
          title: "Scelta dei canali informativi e distributivi",
          to: "/promotion-trip-planning",
        }, */
        {
          title: "Analisi dei canali informativi e distributivi",
          to: "/promotion-channel-positioning",
        },
      ],
    },
    {
      title: "Affermazione dei brand",
      subtitle: "",
      children: [
        {
          title: "Strategie",
          to: "/promotion-strategy-awareness",
        },
        {
          title: "Iniziative",
          to: "/promotion-initiative-awareness",
        },
      ],
    },
    {
      title: "Acquistabilità e visibilità dell'offerta",
      subtitle: "",
      children: [
        {
          title: "Strategie",
          to: "/promotion-strategy-visibility",
        },
        {
          title: "Iniziative",
          to: "/promotion-initiative-visibility",
        },
      ],
    },
  ];

  onSurveyTypeClick(to: string) {
    this.$router.push(to).catch(error => console.log(error));
  }
}
